export const UserConsts = {
    GET_USERS: "GET_USERS",
    GET_USER: "GET_USER",
    UPDATE_USER: "UPDATE_USER",
    DELETE_USER: "DELETE_USER",
    CLEAR_USER_DATA: "CLEAR_USER_DATA",
};